import { DocumentState } from "./types";
import { margin } from "./constants";

export const createDocumentState = (): DocumentState => ({
  x: margin.left,
  y: margin.top,
  startYTable: 46,
  startXSignature: 90
});
